import React, { useState } from 'react';
import AllMarketingPlans from './AllMarketingPlans';
import MarketingPlan from './MarketingPlan';

const MarketingPlanWrapper: React.FC = () => {
  const [selectedPlanId, setSelectedPlanId] = useState<string | null>(null);
  const [selectedPlanName, setSelectedPlanName] = useState<string>('');

  const handlePlanSelect = (planId: string, planName: string) => {
    setSelectedPlanId(planId);
    setSelectedPlanName(planName);
  };

  const handleBackToPlans = () => {
    setSelectedPlanId(null);
    setSelectedPlanName('');
  };

  if (selectedPlanId) {
    return (
      <MarketingPlan
        planId={selectedPlanId}
        planName={selectedPlanName || `Plan ${selectedPlanId}`}
        onBackToPlans={handleBackToPlans}
      />
    );
  }

  return <AllMarketingPlans onPlanSelect={handlePlanSelect} />;
};

export default MarketingPlanWrapper; 